import { render, staticRenderFns } from "./AssignmentScenarios.vue?vue&type=template&id=60377868&scoped=true&"
import script from "./AssignmentScenarios.vue?vue&type=script&lang=js&"
export * from "./AssignmentScenarios.vue?vue&type=script&lang=js&"
import style0 from "./AssignmentScenarios.vue?vue&type=style&index=0&id=60377868&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60377868",
  null
  
)

export default component.exports